/**
 * 找回密码主页
 */

import { useLoaderData } from 'react-router-dom'
import CNF from '../../incs/Config.js';

import FindPasswordNav from './FindPasswordNav.js';
import FindPasswordEntity from './FindPasswordEntity.js';

//  检查参数合法性
const checkParamas = (params) => {
    /***
     * 检验地址的合法性
     * 1.检验时间戳的合法性，相差时间不能超过 Config 中设置的 maxAge 值
     * 2.检验参数的合法性
     */
    let rtv = true;
    while (true) {
        if (!params.name || params.name.split('&').length < 2) {
            rtv = false;
            break;
        }
        let ts = params.name.split('&')[1].split('=');
        if (ts.length < 2) {
            rtv = false;
            break;
        }
        let dt = Date.parse(new Date()) - ts[1] * CNF.tDivisor;
        if (dt < 0 || dt > CNF.maxAge * 1000) {
            rtv = false;
            break;
        }
        let m = params.name.split('&')[0].split('=');
        if (m.length < 2) {
            rtv = false;
            break;
        };
        break;
    }
    return rtv
}

const FindPassword = () => {
    const params = useLoaderData();
    if (!checkParamas(params)) {
        // 检查参数异常返回到安全设置界面
        window.location.href = '/users/security';
    };
    let m = params.name.split('&')[0].split('=');
    let title = '重置密码';

    return (
        <>
            <FindPasswordNav
                title={title}
            />
            <FindPasswordEntity
                title={title}
                m={m[1]}
            />
        </>
    )
}

export default FindPassword;